import React, { useState, useContext, useEffect } from 'react';
import { StoreContext } from "../Store/store.js";
import { Button, Container,  Grid, Input, Image, Segment } from "semantic-ui-react";
import DiscordLogo from '../Images/Discord-Logo+Wordmark-Color.png';
import MenuDisp from './menu.js';
import Wallet from './wallet.js';

import Api from '../Utils/apiAdapter.js';
const api = new Api();

function Discord(props) {
    const { store, actions } = useContext(StoreContext);
    const [DiscordName, setDiscordName] = useState("");
    const [sigText, setSigText]= useState(false);

    useEffect(() => {
        if (store.web3Adapter) {
        }
    }, [store]);

    const SignMessage = async (DiscordName) => {
        let response = await api.request('sig-msg');
        if (!response) {
            return;
        }
        let messageToSign = "(" + response.success.msg + ") Signing this message to verify that my Discord Name is: " + DiscordName;
        console.log(messageToSign);
        let signatureMsg = await store.web3Adapter.signMessage(messageToSign)
        let validate = await api.request('sig-exchange', { msg: messageToSign, signature: signatureMsg });
        if (validate.error !== undefined) {
            setSigText(validate.error);
            return;
        }
        if (validate.success !== undefined){
            setSigText("Your Discord ID has been verified.");
        }
    };

    return (
     
            <div class="ui">
                <MenuDisp states={{ ...props.states }}/>
                <Grid.Row className="pad" centered>
                    <Container textAligned="center">
                        <h1>Discord Verification</h1>  
                        <p>To gain access to the member only channels, please enter your Discord Name including the numbers. (i.e. CashGrab#1234 ) and sign the message.</p>
                        <Wallet states={{ ...props.states }} />
                        <Input style={{paddingRight:"20px"}} placeholder="CashGrab#1234" onChange={(e) => { setDiscordName(e.target.value) }}></Input>
                        <Button color="red" onClick={() => SignMessage(DiscordName)}>Sign Message</Button>
                        <p id="sigText">{sigText ? sigText : ""}</p>
                    </Container>
                </Grid.Row>
            </div>
     
    );
}

export default Discord;
